const automations = {
  pageName: 'Automatizaciones',
  btnCreate: 'Crear',
  btnUseTemplate: 'Usar plantilla',
  mainTabs: {
    titleAutomationsCenter: 'Centro de Automatizaciones',
    titleAutomationsExisting: 'Automatizaciones existentes',
  },
  deleteModal: {
    header: 'Eliminar automatizaciones',
    body: 'Está a punto de eliminar {{num}} automatizaciones.',
    success: 'Las automatizaciones se eliminaron correctamente',
  },
  table: {
    header: {
      name: 'Nombre',
      nextRun: 'Siguiente ejecución',
      lastRun: 'Última ejecución',
      createdAt: 'Fecha de creación',
      createdBy: 'Creado por',
      actionType: 'Tipo de acción',
      status: 'Estado',
      profiles: 'Perfiles',
      suppliers: 'Proveedores',
      attributes: 'Atributos',
      areas: 'Zonas',
      run: 'Ejecutar'
    },
    filters: {
      status: {
        title: 'Estado',
        options: {
          on: 'En',
          off: 'Desactivado',
        },
      },
      profiles: {
        title: 'Perfiles',
      },
      suppliers: {
        title: 'Proveedores',
      },
      attributes: {
        title: 'Atributos',
      },
      areas: {
        title: 'Zonas',
      },
      actionType: {
        title: 'Tipo de acción',
        options: {
          routingProcess: 'Proceso de ruteo',
          busRoute: 'Ruta de autobús',
          driverAssignment: 'Asignación de conductor',
        },
      },
    },
    actions: {
      run: 'Ejecutar ahora',
      duplicate: {
        title: 'Duplicar',
      },
      delete: {
        title: 'Eliminar',
      },
    },
    toasts: {
      delete: {
        success: '¡Eliminado correctamente!',
        error: '¡Ocurrió un error! No se pudo eliminar el zona',
      },
      run: {
        success: 'Automatización en cola. Se ejecutará en breve',
        error: '¡Ocurrió un error! No se pudo ejecutar la automatización',
      },
    },
  },
  wizard: {
    titleCreate: 'Crear',
    titleUpdate: 'Actualizar',
    trigger: {
      title: '1.Activador',
      subTitle: 'Un activador es un evento que comienza su automatización',
      loadingText: 'Espere cargando parámetros.',
      selectTrigger: {
        label: 'Activador',
      },
      btnContinue: 'Continuar',
    },
    action: {
      title: '2.Acción',
      subTitle: 'Una acción es un evento que se realiza después de comenzar',
      loadingText: 'Espere cargando parámetros.',
      selectAction: {
        label: 'Acción',
      },
      btnContinue: 'Continuar',
    },
    information: {
      title: '3.Información',
      subTitle: 'Información común sobre la automatización',
      name: 'Nombre de la automatización',
      description: 'Descripción',
      profile: 'Perfil',
      supplier: 'Proveedor',
      attributes: 'Atributos',
      areas: 'Zona',
      btnSubmit: 'Enviar',
    },
  },
  automationsCenter: {
    tabs: {
      all: 'Todo',
      routingProcess: 'Proceso de ruteo',
      busRoute: 'Ruta de autobús',
      driverAssignment: 'Asignación de conductor',
    },
  },
  toasts: {
    error: 'Algo salió mal',
    successCreated: 'Creado correctamente',
    successUpdated: 'Actualizado correctamente',
  },
};

export default automations;
